import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import L from 'leaflet';
import { Circle, MapContainer, Marker, TileLayer } from 'react-leaflet';
import pinIcon from '../../assets/icons/pin-map.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import targetPinIcon from '../../assets/icons/target-pin-map.png';
const userLocationIcon = new L.Icon({
    iconUrl: pinIcon,
    iconSize: [27, 42],
    iconAnchor: [13, 42],
    popupAnchor: [0, -42],
    shadowUrl: markerShadow,
});
const targetLocationIcon = new L.Icon({
    iconUrl: targetPinIcon,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -20],
});
const LocationTaskResultMap = ({ targetLocation, radius, userPosition, }) => {
    return (_jsx("div", { className: "map-container", children: _jsxs(MapContainer, { center: [targetLocation.lat, targetLocation.lng], zoom: 17, style: { height: '100%', width: '100%' }, zoomControl: false, dragging: false, scrollWheelZoom: false, doubleClickZoom: false, touchZoom: false, keyboard: false, children: [_jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright" tabindex="-1">OpenStreetMap</a>' }), _jsx(Marker, { position: [targetLocation.lat, targetLocation.lng], icon: targetLocationIcon }), userPosition && (_jsx(Marker, { position: [userPosition.lat, userPosition.lng], icon: userLocationIcon })), _jsx(Circle, { center: [targetLocation.lat, targetLocation.lng], radius: radius, pathOptions: {
                        color: '#1C6DF4',
                        fillColor: '#76B8FF',
                        fillOpacity: 0.68,
                        weight: 2,
                    } })] }) }));
};
export default LocationTaskResultMap;
